var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { Api } from '@app/Api';
import { ApprovedChecklistView } from '../ApprovedChecklistView/ApprovedChecklistView';
import { Grid } from '@app/Components/Grid/Grid';
import { Column } from 'devextreme-react/data-grid';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import { Link } from '@app/Components/Link/Link';
import { Modal } from '@app/Components/Modal/Modal';
import { StatusEnum } from '@app/AppConstants';
import { GlobalLoaderWrapper } from '@app/Components/Loader/GlobalLoader/GlobalLoaderWrapper';
var ApprovedChecklistsC = /** @class */ (function (_super) {
    __extends(ApprovedChecklistsC, _super);
    function ApprovedChecklistsC() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._checklists = [];
        _this._loading = false;
        return _this;
    }
    ApprovedChecklistsC.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadChecklists()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ApprovedChecklistsC.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.props.projectId !== prevProps.projectId ||
                            this.props.gateId !== prevProps.gateId ||
                            this.props.hideNAItems !== prevProps.hideNAItems)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._loadChecklists()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ApprovedChecklistsC.prototype._loadChecklists = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, projectId, gateId, hideNAItems, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, projectId = _a.projectId, gateId = _a.gateId, hideNAItems = _a.hideNAItems;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 3, 4]);
                        this._loading = true;
                        _b = this;
                        return [4 /*yield*/, Api.secured.getFunctionalOnlyChecklists({ projectId: projectId, gateId: gateId, hideNAItems: hideNAItems })];
                    case 2:
                        _b._checklists = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this._loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ApprovedChecklistsC.prototype._toggleChecklistsModal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, history, match;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, history = _a.history, match = _a.match;
                        return [4 /*yield*/, this._loadChecklists()];
                    case 1:
                        _b.sent();
                        history.push(match.url);
                        return [2 /*return*/];
                }
            });
        });
    };
    ApprovedChecklistsC.prototype._handleChecklistChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadChecklists()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ApprovedChecklistsC.prototype.render = function () {
        var _this = this;
        var _a = this.props, match = _a.match, gateId = _a.gateId, projectId = _a.projectId, projectCodeName = _a.projectCodeName, gateCodeName = _a.gateCodeName, isProjectTerminatedOrCompleted = _a.isProjectTerminatedOrCompleted;
        return (React.createElement("div", null,
            React.createElement(Grid, { dataSource: this._checklists, loading: this._loading },
                React.createElement(Column, { caption: "Code", dataField: "code", width: 100, alignment: "center", cellRender: function (_a) {
                        var data = _a.data;
                        return data.isEnabled ? React.createElement(Link, { to: "".concat(match.url, "/cl-").concat(data.id) }, data.code) : data.code;
                    } }),
                React.createElement(Column, { caption: "Current Status", dataField: "status", width: 100, alignment: "center" }),
                React.createElement(Column, { caption: "Gate", dataField: "gateDisplayName", width: 100, alignment: "center" }),
                React.createElement(Column, { caption: "Name", dataField: "name", width: 150 }),
                React.createElement(Column, { caption: "Function Short", dataField: "functionCode", width: 100, alignment: "center" }),
                React.createElement(Column, { caption: "Function Full", dataField: "functionName", width: 250 }),
                React.createElement(Column, { caption: "Function Principal Name", dataField: "functionPrincipalName", width: 200 }),
                React.createElement(Column, { caption: "Approvers", dataField: "approvers", minWidth: 300 }),
                React.createElement(Column, { caption: "Rated", dataField: "funcRatingCount", minWidth: 100, cellRender: function (_a) {
                        var data = _a.data;
                        return data.status === StatusEnum.NotApplicable
                            ? ''
                            : "".concat(data.funcRatingCount, "/").concat(data.ratingCountTotal);
                    } }),
                React.createElement(Column, { caption: "Rated PJM", dataField: "pjmRatingCount", minWidth: 100, cellRender: function (_a) {
                        var data = _a.data;
                        return data.status === StatusEnum.NotApplicable
                            ? ''
                            : "".concat(data.pjmRatingCount, "/").concat(data.ratingCountTotal);
                    } }),
                React.createElement(Column, { caption: "Rated GA", dataField: "gaRatingCount", minWidth: 100, cellRender: function (_a) {
                        var data = _a.data;
                        return data.status === StatusEnum.NotApplicable
                            ? ''
                            : "".concat(data.gaRatingCount, "/").concat(data.ratingCountTotal);
                    } })),
            React.createElement(Switch, null, this._checklists.map(function (c) { return (React.createElement(Route, { key: c.id, path: "".concat(match.url, "/cl-").concat(c.id) },
                !c.isEnabled && React.createElement(Redirect, { to: match.url }),
                React.createElement(Modal, { isOpen: true, toggle: _this._toggleChecklistsModal, headerTitle: "Checklist Info", maxWidth: "95%" },
                    React.createElement(GlobalLoaderWrapper, null,
                        React.createElement(ApprovedChecklistView, { checklist: c, gateId: gateId || 0, gateCodeName: gateCodeName || '', projectId: projectId, projectCodeName: projectCodeName, onChecklistChanged: _this._handleChecklistChanged, isProjectTerminatedOrCompleted: isProjectTerminatedOrCompleted }))))); }))));
    };
    __decorate([
        observable
    ], ApprovedChecklistsC.prototype, "_checklists", void 0);
    __decorate([
        observable
    ], ApprovedChecklistsC.prototype, "_loading", void 0);
    __decorate([
        action.bound
    ], ApprovedChecklistsC.prototype, "_loadChecklists", null);
    __decorate([
        action.bound
    ], ApprovedChecklistsC.prototype, "_toggleChecklistsModal", null);
    __decorate([
        action.bound
    ], ApprovedChecklistsC.prototype, "_handleChecklistChanged", null);
    ApprovedChecklistsC = __decorate([
        observer
    ], ApprovedChecklistsC);
    return ApprovedChecklistsC;
}(React.Component));
export var ApprovedChecklists = withRouter(ApprovedChecklistsC);
